<template>
  <div class="sign-up">
    <h2>Sign Up</h2>
    <div class="sign-up-wrap">
      <table>
        <tr>
          <th aria-label="company" scope="row" rowspan="3">Company</th>
          <td>
            <div class="select">
              <select aria-labelledby="company" v-model="model.companyTypeId">
                <option value="">{{ $t('signUp.subsidiary') }}</option>
                <option
                  v-for="item in companyData" :key="item.id"
                  :value="item.id">{{ item.name }}</option>
              </select>
            </div>
            <strong class="wrong" v-if="errors.companyTypeId">* {{ $t(errors.companyTypeId) }}</strong>
          </td>
        </tr>
        <tr>
          <td>
           <div class="select">
              <select aria-labelledby="company" v-model="model.companyId">
                <option value="">{{ $t('signUp.enterprise') }}</option>
                <template v-if="model.companyTypeId">
                  <option
                    v-for="item in companies" :key="item.id"
                    :value="item.id">{{ item.name }}</option>
                </template>
              </select>
            </div>
            <strong class="wrong" v-if="errors.companyId">* {{ $t(errors.companyId) }}</strong>
          </td>
        </tr>
        <tr>
          <td>
             <div class="select select_department">
              <input type="text" aria-labelledby="department"
                v-model.trim="model.department" maxlength="20"
                :placeholder="$t('signUp.department')">
            </div>
            <strong class="wrong" v-if="errors.department">* {{ $t(errors.department) }}</strong>
          </td>
        </tr>
        <tr>
          <th aria-label="name" scope="row">Name</th>
          <td>
            <input type="text" name="userName_first" aria-labeledby="name"
              v-model.trim="model.firstName" title="first" placeholder="First Name" maxlength="20" />
            <input type="text" name="userName_last" aria-labeledby="name"
              v-model.trim="model.lastName" title="last" placeholder="Last Name" maxlength="20" />
            <strong class="wrong" v-if="errors.firstName">* {{ $t(errors.firstName) }}</strong>
            <strong class="wrong2" v-if="errors.lastName">* {{ $t(errors.lastName) }}</strong>
          </td>
        </tr>
        <tr>
          <th aria-label="Tel" scope="row">Tel</th>
          <td>
            <div class="select">
              <select aria-labelledby="Tel" title="Country Code" v-model="model.callingCode">
                <option value="">{{ $t('signUp.countryCode' )}}</option>
                <option
                  v-for="item in callingCodes" :key="item.code"
                  :value="item.code">
                  +{{ item.code }}</option>
              </select>
            </div>
            <input type="text" name="tel" aria-labeledby="Tel" v-model.trim="model.phone" />
            <p class="description">{{ $t('common.withoutDash') }}</p>
            <strong class="wrong"
              v-if="errors.callingCode || errors.phone">* {{ $t(errors.callingCode) || $t(errors.phone) }}</strong>
          </td>
        </tr>
        <tr>
          <th aria-label="id" scope="row">ID (E-mail)</th>
          <td>
              <input type="text" name="id" aria-labeledby="id" placeholder="example@example.com" maxlength="60"
                v-model.trim="model.email" />
              <button type="button" class="btn_2"
                      :disabled="isEmailValid"
                      @click="onEmailCheck">Available Check</button>
              <button type="button" class="btn_3"
                      @click="onRequestEmail">Request Domain</button>
              <input type="text" name="certification" placeholder="Certification Code" maxlength="5"
                v-if="isEmailValid" v-model.trim="model.certification" />
              <strong class="wrong" v-if="errors.certification || errors.email">
                * {{ $t(errors.certification || errors.email) }}
              </strong>
          </td>
        </tr>
        <tr>
          <th aria-label="password" scope="row">Password</th>
          <td>
              <input type="password" name="password" aria-labeledby="password" placeholder="Password"
                v-model="model.password" />
              <p class="description">
                Please enter a password combination of alphabet, numeric, special character with more than 8 characters long. More than 4 consecutive characters are not allowed.
              </p>
              <input type="password" name="confirm_password" placeholder="Password Confirm"
                v-model="model.passwordConfirm" />
              <strong class="wrong" v-if="errors.password">* {{ $t(errors.password) }}</strong>
              <strong class="wrong2" v-if="errors.passwordConfirm">* {{ $t(errors.passwordConfirm) }}</strong>
          </td>
        </tr>
        <tr>
          <th><span class="haze">Terms</span></th>
          <td class="agree">
            <p>
              <input id="terms" type="checkbox" value="true"
                v-model="model.acceptTerms"
                true-value="1"
                :false-value="null" /><label for="terms">Agree to the <router-link :to="{ name: 'Terms' }" target="_blank" title="Open in a new window">Terms of service</router-link></label><br>
              <strong class="wrong" v-if="errors.acceptTerms">* Please agree to the terms of service.</strong>
            </p>
            <p>
              <input id="privacy" type="checkbox" value="true"
                v-model="model.acceptPrivacy"
                true-value="1"
                :false-value="null" /><label for="privacy">Agree to the Privacy Policy
              <router-link :to="{ name: 'PrivacyEurope' }" target="_blank" title="Open in a new window">(Europe)</router-link>,
              <router-link :to="{ name: 'PrivacyGlobal' }" target="_blank" title="Open in a new window">(Global)</router-link></label><br>
              <strong class="wrong" v-if="errors.acceptPrivacy">* Please agree to the privacy policy.</strong>
            </p>
          </td>
        </tr>
      </table>
      <div class="btns">
        <p>
          <button type="button" class="btn_s1" @click="onSignUp">Sign Up</button>
        </p>
        <p>
          {{ $t('signUp.haveAccount') }} <router-link :to="{ name: 'SignIn' }">Sign In</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import accountApi from '@/api/account'
import modalEvent from '@/lib/modal-event'
import ajaxHandlerMixin from '@/mixins/ajax-handler'
import { adminEmail } from '@/lib/utils'

export default {
  name: 'SignUp',
  mixins: [ajaxHandlerMixin],
  data () {
    return {
      errors: {},
      validatedEmail: null,
      isEmailValid: false,
      model: {
        companyTypeId: '',
        companyId: '',
        department: null,
        firstName: null,
        lastName: null,
        callingCode: '',
        phone: null,
        email: null,
        certification: null,
        password: null,
        passwordConfirm: null,
        acceptTerms: null,
        acceptPrivacy: null
      }
    }
  },
  computed: {
    ...mapGetters(['companyData', 'callingCodes']),
    companies () {
      if (this.model.companyTypeId) {
        const index = this.companyData.findIndex(item => {
          return item.id === this.model.companyTypeId
        })

        return this.companyData[index].Companies
      }
      return []
    }
  },
  watch: {
    'model.companyTypeId' (val) {
      this.model.companyId = ''
    },
    'model.email' (val) {
      if (val) {
        val = val.toLowerCase().trim()
      }
      if (this.validatedEmail && this.validatedEmail === val) {
        this.isEmailValid = true
      } else {
        this.isEmailValid = false
      }
    }
  },
  created () {
    Promise.all([
      this.fetchCompanyData(),
      this.fetchCallingCodes()
    ]).catch(err => {
      const isHandled = this.handleAjaxError(err)

      if (!isHandled) {
        alert(this.$t('system.operationFailed'))
      }
    })
  },
  methods: {
    ...mapMutations(['setJustSignUp']),
    ...mapActions(['fetchCompanyData', 'fetchCallingCodes']),
    onSignUp () {
      accountApi.add(this.model).then(response => {
        this.setJustSignUp(true)
        this.$router.push({ name: 'AccountStatus' })
      }).catch(err => {
        this.handleAjaxError(err)

        if (this.isValidationError(err)) {
          if (!this.isEmailValid || (this.errors.certification && this.errors.email)) {
            this.errors.email = 'signUp.checkAvailability'
          }
        }
      })
    },
    onEmailCheck () {
      accountApi.checkEmail(this.model.email).then(response => {
        modalEvent.openDialog({
          message: this.$t(response.data.message, { adminEmail }),
          ok: this.$t('common.confirm')
        }).then(() => {
          if (response.data.isValid) {
            this.validatedEmail = this.model.email.toLowerCase().trim()
            this.isEmailValid = true
            this.errors.email = null
          }
        })
      })
    },
    onRequestEmail () {
      accountApi.requestEmail({
        department: this.model.department,
        firstName: this.model.firstName,
        lastName: this.model.lastName,
        email: this.model.email
      }).then(response => {
        if (response.data.success) {
          this.handleAjaxError({})
          modalEvent.openDialog({
            message: this.$t('signUp.requestSent'),
            ok: this.$t('common.confirm')
          })
        }
      }).catch(err => {
        this.handleAjaxError(err)
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.sign-up {
  width: 1194px;
  padding: 0 15px;
  margin: 15px auto 0;

  h2 {
    font-size: 30px;
    font-weight: 600;
    color: #151515;
    padding: 40px 0 13px;
    display: inline-block;
    margin: 0 10px;
  }

  .sign-up-wrap {
    border-radius: 10px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    padding: 20px 20px 50px;
  }

  table {
    width: 100%;
    margin: 15px auto;
  }

  th {
    vertical-align: top;
    line-height: 36px;
    color: #666666;
    width: 200px;
    padding-left: 20px;
  }

  td {
    position: relative;
    padding-bottom: 40px;

    input,
    .select {
      width: 430px;
    }

    .description {
      display: block;
      margin: 5px;
      font-size: 12px;
      color: #999999;
      width: 650px;
    }

    .wrong,
    .wrong2 {
      position: absolute;
      left: 0;
      bottom: 15px;
      font-size: 12px;
      font-weight: normal;
      color: #ec0047;
      white-space: nowrap;
    }

    .wrong2 {
      left: 180px;
    }
  }

  .tip-input-tel {
    font-size: 13px;
  }

  .btns {
    text-align: center;

    p:last-child {
      margin-top: 30px;
      font-size: 14px;

      a {
        color: #ec0047;
      }
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-ms-expand { /* for IE */
      display: none;
    }
  }

  .select_department::before,
  select[aria-labelledby='department']:before {
    display: none;
  }

  .select_department {
    &.select:before {
      right: 230px;
    }

    input::placeholder {
      color: #999;
      opacity: 1;
    }

    input:-ms-input-placeholder { /* for IE */
      color: #999;
    }
  }

  .agree {
    font-size: 14px;
    color: #757575;
    padding-bottom: 24px;

    p {
      position: relative;

      &:first-child {
        margin-bottom: 4px;
      }
    }

    a {
      text-decoration: underline;
    }

    input {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .wrong {
      position: static;
      margin-left: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/guest/SignUp.vue